import React from "react";
import { Routes, Route, useParams, Navigate } from "react-router-dom";
import { Pages } from "components/pages";
import { PermissionGuard } from "components/permissions";
import StandConst from "components/stand/stand-const";

const StandsRoute: React.FC = () =>
{
  function RedirectToLang()
  {
    const { group_id } = useParams<{ group_id: string }>();
    return <Navigate to={`/stand-types/edit/${group_id}/de/`} />;
  }

  return (
    <PermissionGuard
      permission={StandConst.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<Pages.Stands />} />

        <Route
          path="edit/:group_id/"
          element={<RedirectToLang />}
        />

        <Route
          path="edit/:group_id/:lang/*"
          element={<Pages.Stand />}
        />

        <Route
          path="create/:lang"
          element={<Pages.Stand />}
        />
      </Routes>
    </PermissionGuard>
  );
};

export default StandsRoute;